import { useAtom } from '@reatom/npm-react'
import { motion } from 'motion/react'
import styled from 'styled-components'

import { isLoggedInAtom } from '@root/entities/auth'
import { tradeOrderTypeAtom } from '@root/features/trade/trading'
import { AnimateHeight } from '@root/shared/ui-kit'

import { TradingControlsBuyButton } from '../../common/trading-controls-buy/trading-controls-buy-button'
import { TradingControlsBuyLimit } from '../../common/trading-controls-buy/trading-controls-buy-limit'
import { TradingControlsBuyQuote } from '../../common/trading-controls-buy/trading-controls-buy-quote'
import { TradingGas } from '../trading-gas'

import { TradingControlsBuyAmount } from './trading-controls-buy-amount'

import type { BuyControlsModel } from '../../../atoms/common'
import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
  onSettingsOpen: () => void
  model: BuyControlsModel
}

export const TradingControlsBuyForm: React.FC<Props> = ({
  pair,
  onSettingsOpen,
  model,
}) => {
  const [tradeOrderType] = useAtom(tradeOrderTypeAtom)
  const [isLoggedIn] = useAtom(isLoggedInAtom)

  return (
    <Root>
      <TradingControlsBuyAmount
        amountInputModel={model.amountInputModel}
        pair={pair}
      />
      {tradeOrderType === 'limit' ? (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <TradingControlsBuyLimit model={model} />
        </motion.div>
      ) : undefined}
      {isLoggedIn ? <TradingGas onSettingsOpen={onSettingsOpen} /> : undefined}
      <QuoteBuyGroup>
        <AnimateHeight>
          <TradingControlsBuyQuote pair={pair} model={model} />
        </AnimateHeight>
        <BuyButton pair={pair} model={model} />
      </QuoteBuyGroup>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 10px;
`

const BuyButton = styled(TradingControlsBuyButton)`
  margin-inline: 10px;
`

const QuoteBuyGroup = styled.div`
  display: grid;
`
